import { useMutation } from '@tanstack/react-query'
import { useOrpcTanstackQueryUtils } from '../orpc'

/**
 * Chat messages are sent client -> Convex directly (real-time). To also deliver
 * a native push, the sender's client calls this API endpoint after a successful
 * send; the API creates a `message` notification per recipient (inbox row +
 * push, gated by each recipient's `notifyChat` toggle). Best-effort — failures
 * must not block the chat flow.
 */
export function useNotifyNewMessage() {
  const orpc = useOrpcTanstackQueryUtils()
  return useMutation(orpc.message.notifyNewMessage.mutationOptions())
}
